import { notification } from "antd";

let isTokenExpiredNotified = false;

export const alertError = (msg, description) => {
  let desc = description;
  if (description instanceof Error) {
    desc = description.message || String(description);
  } else if (typeof description === "object" && description !== null) {
    desc = description.message || description.error || JSON.stringify(description);
  } else if (typeof description !== "string" && typeof description !== "number") {
    desc = String(description || "");
  }

  // If token is invalid or expired, notify user and avoid spamming popups
  const isTokenExpired =
    typeof desc === "string" &&
    (desc.toLowerCase().includes("token is invalid") ||
      desc.toLowerCase().includes("token expired") ||
      desc.toLowerCase().includes("please login again"));

  if (isTokenExpired) {
    if (isTokenExpiredNotified) {
      return;
    }
    isTokenExpiredNotified = true;
    setTimeout(() => {
      isTokenExpiredNotified = false;
    }, 5000);

    try {
      localStorage.removeItem("state");
    } catch (e) {
      // ignore
    }
  }

  notification["error"]({
    message: typeof msg === "string" ? msg : "Error",
    description: desc,
  });
};


